import { Input } from '@root/components'
import { INojaFormProps } from '@root/query'
import React from 'react'
import { useForm, get } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { UseMutationResult } from '@tanstack/react-query'
import styled from 'styled-components'

interface Props {
  defaultFormValues?: Partial<INojaFormProps>
  onClose?: () => void
  onCreate?: (data: Partial<any>) => void
  sendFormMutation: UseMutationResult
}

const NojaForm: React.FC<Props> = ({ defaultFormValues, sendFormMutation }) => {
  const [t] = useTranslation()

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<Partial<INojaFormProps>>({
    defaultValues: defaultFormValues
  })

  const onSubmit = async (data: INojaFormProps) => {
    try {
      sendFormMutation.mutate(data)
    } catch (error) {
      console.error(error)
      return null
    }
  }

  return (
    <StyledWrapper>
      <form id="noja-form" onSubmit={handleSubmit(onSubmit)}>
        <Input
          required={true}
          label={t('nojaPage.form.businessName')}
          errors={get(errors, 'business_name')}
          {...register('business_name', {
            required: { value: true, message: t('validation.required') }
          })}
        ></Input>

        <Input
          required={true}
          label={t('nojaPage.form.businessId')}
          errors={get(errors, 'business_id')}
          {...register('business_id', {
            required: { value: true, message: t('validation.required') }
          })}
        ></Input>

        <Input
          required={true}
          label={t('nojaPage.form.contactName')}
          errors={get(errors, 'contact_name')}
          {...register('contact_name', {
            required: { value: true, message: t('validation.required') }
          })}
        ></Input>

        <Input
          required={true}
          label={t('nojaPage.form.email')}
          errors={get(errors, 'contact_email')}
          {...register('contact_email', {
            required: { value: true, message: t('validation.required') }
          })}
        ></Input>

        <Input
          required={true}
          label={t('nojaPage.form.phone')}
          errors={get(errors, 'contact_phone')}
          {...register('contact_phone', {
            required: { value: true, message: t('validation.required') }
          })}
        ></Input>
      </form>
    </StyledWrapper>
  )
}

export default NojaForm

const StyledWrapper = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;

  form {
    flex: 1;
    overflow: auto;
  }
`
